module.exports = __webpack_public_path__ + "static/media/md-folder.d95b0897.svg";